<template>
  <section class="hr-section hr-adv" aria-labelledby="hr-adv-title">
    <div class="hr-container">
      <div class="hr-adv__card">
        <h2 id="hr-adv-title" class="hr-section-title hr-section-title--center">Почему выбирают нас</h2>
        <ul class="hr-adv__grid">
          <li v-for="item in items" :key="item.title" class="hr-adv__item">
            <span class="hr-adv__icon"><HrIcon :name="item.icon" :image="item.iconImage" /></span>
            <h3 class="hr-adv__title">{{ item.title }}</h3>
            <p class="hr-adv__text">{{ item.text }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'

export default {
  name: 'HrAdvantages',
  components: { HrIcon },
  props: {
    items: { type: Array, required: true },
  },
}
</script>
